const { checkNotEmpty } = require("./common");
/**
 *
 * @param {title: string, messages: string[], images: string[]}[] objs
 */
export const exampleDoc = (objs, sweet) => {
    const ua = navigator.userAgent.toLowerCase();
    const isAndroid = ua.indexOf("android") > -1;
    let contents = convertToContent(objs);
    // console.log(contents);
    sweet.fire({
        html: `
            <div id="swal-example-container">
                <div id="header"></div>

                <div id="header-scroll" style="
                    text-align: center;
                    background-color: #FFFFFF !important;
                    border-radius: 0 0 32px 32px;
                    position: fixed;
                    width: 100%;
    ${isAndroid ? "padding-top: 54px; padding-bottom: 15px;" : "height: 94px;"}
                    top: 0;
                    left: 0;
                    display: grid;
                    grid-template-rows: auto auto;
                    row-gap: 8px;
                    padding-left: 16px;
                    padding-right: 16px;
                    ">

                    <!-- Row 1 -->
                    <div style="
                        display: grid;
                        grid-template-columns: 1fr 5fr 1fr;
                        align-items: center;
                    ">
                    <div></div>
                    <div>
                        <span id="header-scroll-title" class="font-anuphan-bold-20 text-revamp-color-black" style="font-weight: 600;">ตัวอย่างเอกสาร</span>
                    </div>
                    <div style="display: flex; justify-content: center;">
                        <button id="swal-example-close" class="close-button-circle" style="
                            width: 40px;
                            height: 40px;
                            background-color: white;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                        ">
                            <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAA7DAAAOwwHHb6hkAAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAAALxJREFUSIntlTEOgkAQRd9Xr+BGz8PR6Yg2UngHbkA1NkujszBLJEbjJCQUb/4jOwPIzNiydpum/wWrBZJaSRdJaSlAUsps6wJm9nIBHWBADySPyVzKjAGdyxQaj8AtN96Bc4A5hQVLkmj4rKAkqQlfFDjn3D/dF+cTFjiScLiZhd+DKXiqA7CPdX7yiLyBeoNfJZjblhpJdXitpCR426eitEUjcAUaMxtmFmQAmsyOHqP8JJvVj/5wvkrwAKJ7QwYPXbwbAAAAAElFTkSuQmCC" alt="icon close" />
                        </button>
                    </div>
                    </div>

                    <!-- Row 2 -->
                    <div style="text-align: center;">
                        <span id="header-scroll-desc" class="font-anuphan-regular-14 text-revamp-color-grey">สามารถขยายเพื่อดูรูปเอกสารได้</span>
                    </div>

                    <div id="swal-example-page" class="swal-example-page"></div>
                </div>

                <div class="pinch-zoom" id="zoomTarget">${contents}</div>
            </div>
        `,
        showConfirmButton: false,
        showCancelButton: false,
        showCloseButton: false,
        showClass: {
            popup: `animate__fadeSlowShow`,
        },
        hideClass: {
            popup: `animate__fadeSlowHide`,
        },
        customClass: {
            popup: "no-padding-popup transparent-popup",
            htmlContainer: "no-padding-container",
            closeButton: "close-button-circle",
            footer: "swal-example-footer",
        },
        width: "fit-content",
        padding: "0",
        grow: "fullscreen",
        background: "rgb(235, 237, 247)",
        didOpen: () => {
            const el = document.getElementById("zoomTarget");
            let initialDistance = 0;
            let currentScale = 1;
            let zoomed = false;

            el.addEventListener("dblclick", function () {
                zoomed = !zoomed;
                zoomTarget.style.transform = zoomed ? "scale(2)" : "scale(1)";
            });

            function getDistance(touches) {
                const [touch1, touch2] = touches;
                const dx = touch2.clientX - touch1.clientX;
                const dy = touch2.clientY - touch1.clientY;
                return Math.sqrt(dx * dx + dy * dy);
            }

            el.addEventListener("touchstart", (e) => {
                if (e.touches.length === 2) {
                    initialDistance = getDistance(e.touches);
                }
            });

            let EVENT = null;
            const scheduleScale = (scale) => {
                if (EVENT == null) {
                    el.style.transform = `${currentScale * scale < 1 ? `scale(1)` : `scale(${scale})`
                        }`;
                    EVENT = null;
                }
            };

            el.addEventListener("touchmove", (e) => {
                // console.log("Event touch", e);
                if (e.touches.length === 2) {
                    e.preventDefault();

                    const newDistance = getDistance(e.touches);
                    const scale = newDistance / initialDistance;
                    zoomed = true;
                    const realScale = currentScale * scale;
                    if (realScale > 1 && realScale <= 2) {
                        scheduleScale(realScale);
                    }
                }
            });

            el.addEventListener("touchend", (e) => {
                if (e.touches.length < 2) {
                    const transform = el.style.transform;
                    const match = transform.match(/scale\(([^)]+)\)/);
                    if (match) {
                        currentScale = parseFloat(match[1]);
                    }
                }
            });

            // Handle button close
            const buttonClose = document.getElementById("swal-example-close");
            if (buttonClose) {
                buttonClose.addEventListener("click", () => {
                    sweet.clickCancel();
                });
            }
            // Handle header height
            const headerScrollfixedUI = document.getElementById("header-scroll");

            const headerfixedUI = document.getElementById("header");
            if (headerScrollfixedUI && headerfixedUI) {
                headerfixedUI.style.height = `${headerScrollfixedUI.offsetHeight}px`;
            }
            // Handle page number
            const container = document.getElementById("swal2-html-container");
            const page = document.getElementById("swal-example-page");
            if (container && page) {
                if (checkNotEmpty(objs)) {
                    page.innerText = `0/${objs.length}`;
                    let timeoutId;
                    const elementsToCheck = document.querySelectorAll(
                        ".swal-example-page-container"
                    );
                    container.addEventListener("scroll", () => {
                        handleScroll(elementsToCheck, page, objs.length);
                        if (page.style.display !== "flex") {
                            page.style.display = "flex";
                        }
                        clearTimeout(timeoutId);
                        timeoutId = setTimeout(() => {
                            page.style.display = "none";
                        }, 3000);
                    });
                }
            }
        },
    });
};

const isVisibleInViewport = (element) => {
    const rect = element.getBoundingClientRect();
    const elementCenter = rect.top + rect.height / 2;
    const windowTop = window.visualViewport?.offsetTop || 0;
    const windowHeight = window.visualViewport?.height || window.innerHeight;

    const visible =
        elementCenter >= windowTop && elementCenter <= windowTop + windowHeight;

    return {
        visible: visible,
        id: visible ? element.id : null,
    };
};

function handleScroll(elementsToCheck, page, size) {
    elementsToCheck.forEach((element) => {
        const visibility = isVisibleInViewport(element);
        if (visibility.visible) {
            page.innerText = `${visibility.id.replace(
                "swal-example-page-",
                ""
            )}/${size}`;
        }
    });
}

const convertToContent = (objs) => {
    let contents = "";
    if (checkNotEmpty(objs) && objs.length > 0) {
        objs.forEach((obj, index) => {
            if (
                !checkNotEmpty(obj["title"]) &&
                checkNotEmpty(obj["images"]) &&
                obj["images"].length > 0 &&
                !checkNotEmpty(obj["messages"])
            ) {
                contents += createContentOnlyImage(obj["images"], index);
            } else {
                contents += createContentWithMessage(obj, index);
            }
        });
    }
    return contents;
};

const createContentWithMessage = (obj, index) => {
    let contents = `<div id="swal-example-page-${index + 1
        }" class="swal-example-page-container" style="width: 100%; margin-top: ${index > 0 ? "35px" : "16px"
        }; text-align: left; background-color: #fff; padding: 30px 10px 30px 10px;">
            ${getTitle(obj["title"])}
            ${getMessage(obj["messages"])}
            ${getImage(obj["images"], "width: 100%;")}
        </div>`;
    return contents;
};

const createContentOnlyImage = (imgs, index) => {
    let contents = `<div id="swal-example-page-${index + 1
        }" class="swal-example-page-container" style="width: 100%; text-align: left;">
            ${getImage(imgs, "width: 100%;")}
        </div>`;
    return contents;
};

const getTitle = (title) => {
    return checkNotEmpty(title)
        ? `<p class="font-anuphan-bold-18 text-revamp-color-black" style="float: left;">${title}</p><br />`
        : ``;
};

const getMessage = (msgs) => {
    let messages = "";
    if (checkNotEmpty(msgs)) {
        messages += `<ul style="float: left; display: flex; flex-direction: column; width: 100%; margin-top: 12px; gap: 5px;">`;
        msgs.forEach(
            (msg) =>
            (messages += `<li class="example_doc" 
                    style="float: left; 
                    display: grid;
                    grid-template-columns: 1fr 11fr;
                    row-gap: 10px;
                    margin-left: -7vw;
                    ">
                        <span style="font-size: 4rem; color: var(--color-primary); line-height: 22px;">•</span>
                        <h4 class="text-revamp-color-black font-anuphan-regular-14">${msg}</h4>
                    </li>`)
        );
        messages += `</ul>`;
    }
    return messages;
};

const getImage = (imgs, style) => {
    let contents = "";
    if (checkNotEmpty(imgs)) {
        imgs.forEach(
            (item) => (contents += `<img src="${item}" style="${style}" />`)
        );
    }
    return contents;
};
